export function roundNumber(value, digits = 0, fallback = 0) {
  const normalized = Number(value);
  if (!Number.isFinite(normalized)) return fallback;

  const precision = Math.max(0, Math.trunc(Number(digits) || 0));
  const factor = 10 ** precision;
  const sign = normalized < 0 ? -1 : 1;

  return (sign * Math.round((Math.abs(normalized) + Number.EPSILON) * factor)) / factor;
}
